import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import { Typography } from "@material-ui/core";
import ErrorIcon from '@material-ui/icons/Error';

const AlertDialog = ({ close, message, options }) => {
    return (
        <Dialog
            open={true}
            onClose={close}
            keepMounted
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle id="alert-dialog-slide-title">{options.title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description" style={{ display: 'flex', minWidth: 300, justifyContent: 'center', alignItems: 'center' }}>
                    {!options.hideIcon && <ErrorIcon style={{ fontSize: 50, marginRight: 16 }} />}
                    <Typography style={{ flex: 1 }}>{message}</Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {options.actions &&
                options.actions.map((action, index) => (
                    <Button
                        onClick={() => {
                            action.onClick();
                            close();
                        }}
                        color="primary"
                        key={index}
                    >
                        {action.copy}
                    </Button>
                ))}
                <Button onClick={close} color="primary">
                    {options.closeCopy || "Okay"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AlertDialog;